import Base from './base'
import Request from '@utils/request'
import { isOwnProperty, toQueryString, newFormData } from '@utils'

class User extends Base {
  async getUserProfile () {
    const response = await Request.get('/api/profile')
    return response
  }

  async updateProfile (payload) {
    const data = newFormData(payload)

    const response = await Request.custom({
      url: '/api/profile',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async show (id, params = {}) {
    const url = `/api/admin/users/${id}?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }

  async store (payload) {
    const data = newFormData(payload)

    const response = await Request.custom({
      url: '/api/admin/users',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async update (id, payload) {
    if (isOwnProperty(payload, 'id')) {
      delete payload.id
    }

    const data = newFormData(payload)

    const response = await Request.custom({
      url: `/api/admin/users/${id}`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async delete (id) {
    const response = await Request.delete(`/api/admin/users/${id}`)

    return response
  }

  async all () {
    const response = await Request.get('/api/users')
    return response
  }
}

export default new User()
